function Loader() {
  return (
    <div id="loader-wrapper" style={{ zIndex: '9999999' }}>
      <div id="loader">
        <div className="cssload-container">
          <ul className="cssload-flex-container">
            <li>
              <span className="cssload-loading" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Loader;
